export function courseHasCalculator(courseId) {
    // 1 Geschiedenis
    // 4 Duits
    // 7 Nederlands
    // 9 Studiebegeleiding
    // 10 Engels
    // 11 Spaans
    // 18 Frans
    // 38 Loopbaanoriëntatie en -begeleiding
    // 40 Latijn
    // 60 Grieks
    // 62 Lichamelijke Opvoeding
    // 70 Studievaardigheden
    // 74 Levensbeschouwing
    // 75 Maatschappijleer
    // 80 Godsdienst
    // 116 Beeldende vorming
    // 120 Filosofie
    // 125 Mediawijsheid
    // 128 Culturele en Kunstzinnige Vorming
    // 149 Maatschappijwetenschappen
    // 153 Burgerschap
    // 165 Maatschappijkunde
    // 170 Mentoraat
    // 182 Literatuur
    // 220 Tekenen
    const coursesWithoutCalculator = [
        1, 4, 7, 9, 10, 18, 38, 40, 60, 62, 70, 74, 75, 80, 116, 120, 125, 128, 149, 153, 11, 165, 170, 182, 220
    ]

    return !coursesWithoutCalculator.includes(courseId)
}
